import WorkspaceUserProfile from "./Workspace/WorkspaceUserProfile";

export default function YourProfile() {
  return <WorkspaceUserProfile />;
}
